import React from "react";

import styles from "./styles.module.scss";

export default function Loading() {
    return (
        <div className={styles.loading}>
            <span className={styles.loading__circle} />
            <span className={styles.loading__circle} />
            <span className={styles.loading__circle} />
        </div>
    );
}
